import template from './category-pager-toolbox.view.html';
function MenuDirective () {
  return {
    restrict: 'E',
    template
  };
}

MenuDirective.$inject = [];

export default MenuDirective;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.directive.js
 **/